import { authenticatedFetch } from './base'

/**
 * Get a list of languages stored in the system
 *
 * @returns {*} - response containing a list of languages 
 */
export const fetchLanguages = () => {
    return authenticatedFetch(`/api/language`,
            {
                method: 'GET',
                headers: { 'content-type': 'application/json' }
            })
        .then(function(response) {
            if (response.status === 200) {
                return response.json()
            }
        })
        .then(function(circle) {
            return circle
        })
}

/**
 * Get ID of current language
 *
 * @returns {*} - response containing language ID
 */
export const fetchLanguage = () => {
    return authenticatedFetch(`/api/language/id`, { method: 'get' })
        .then(function (response) {
            if (response.status === 200) {
                return response.json()
            }
        })
        .then(function (data) {
            return data
        })
}